import { useDispatch } from 'react-redux'
import { userLogout } from 'Reducers/Auth/actions'
import { PATHS } from 'Config/Routing/paths'
import { authorization } from '../../../Module/Auth/Auth'

const Logout = () => {
  const dispatch = useDispatch()

  dispatch(userLogout())
  authorization.logout()
  window.location.href = PATHS.main.login

  return null
}

export default Logout
